import { CssBaseline, ThemeProvider } from '@mui/material';
import { useNavigate, useRoutes } from 'react-router-dom';
import Router from './routes/Router';
// import './Global.css';
import './index.css';

import { baselightTheme } from './theme/DefaultColors';

import { useEffect } from 'react';
import { useMain } from './views/hooks/useMain';

function App() {
  const routing = useRoutes(Router);
  const theme = baselightTheme;

  const { getStaffById, setActiveStaffId, setBranchId, setActiveStaffData } = useMain();
  const navigate = useNavigate();

  const getData = async (id, branchId) => {
    const queryParams = `?branchId=${branchId}`;
    try {
      const res = await getStaffById(id, queryParams);
      console.log(res);
      if (res.statusCode === 200) {
        setActiveStaffData(res.data);
        setBranchId(res?.data?.branchDetails);
      } else {
        localStorage.removeItem('salon-branch');
        localStorage.removeItem('salon-staff');
        navigate('/auth/login');
      }
    } catch (error) {
      localStorage.removeItem('salon-branch');
      localStorage.removeItem('salon-staff');
      navigate('/auth/login');
    }
  };

  useEffect(() => {
    const id = JSON.parse(localStorage.getItem('salon-staff'));
    const branchId = JSON.parse(localStorage.getItem('salon-branch'));
    if (id && branchId) {
      setActiveStaffId(id);
      getData(id, branchId);
    } else {
      navigate('/auth/login');
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {routing}
    </ThemeProvider>
  );
}

export default App;
